var z = Object.defineProperty;
var Q = (s, e, t) => e in s ? z(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var u = (s, e, t) => (Q(s, typeof e != "symbol" ? e + "" : e, t), t);
let S = !1;
function q(s) {
  S = s;
}
const w = (s) => (...e) => {
  S && console[s](...e);
}, f = {
  error: w("error"),
  warn: w("warn"),
  log: w("log")
}, J = /* @__PURE__ */ new Set([
  "Symbol",
  "Text",
  "Integer",
  "Number",
  "Boolean",
  "Date",
  "Location",
  "Object"
]);
function E(s, e, t, i) {
  var n, o;
  t in s && (s[t] = ((o = (n = e.fields) == null ? void 0 : n[t]) == null ? void 0 : o[i]) ?? null);
}
function O(s) {
  var e;
  return !!(J.has(s.type) || s.type === "Array" && ((e = s.items) == null ? void 0 : e.type) === "Symbol");
}
function g(s) {
  var t;
  const e = {
    ...s,
    from: "live-preview",
    location: window.location.href,
    version: "2.2.0"
    // TODO: set this automatically during publish (TOL-1178)
  };
  (t = window.top) == null || t.postMessage(
    e,
    "*"
  );
}
function be(s, e = 100) {
  let t;
  return (...i) => {
    clearTimeout(t), t = setTimeout(() => {
      s.apply(this, i);
    }, e);
  };
}
class P {
  constructor(e, t) {
    u(this, "storageKey");
    u(this, "value");
    this.storageKey = e, this.value = this.restoreSessionData() || t;
  }
  restoreSessionData() {
    try {
      const e = window.sessionStorage.getItem(this.storageKey), t = e ? JSON.parse(e) : null;
      return Array.isArray(t) ? new Map(t) : null;
    } catch {
      return null;
    }
  }
  get(e) {
    return this.value.get(e);
  }
  set(e, t) {
    this.value.set(e, t);
    try {
      window.sessionStorage.setItem(
        this.storageKey,
        JSON.stringify(Array.from(this.value.entries()))
      );
    } catch {
      f.warn(`StorageMap: Failed to set data for key "${e}" in sessionStorage`);
    }
  }
  clear() {
    this.value.clear();
    try {
      window.sessionStorage.removeItem(this.storageKey);
    } catch {
      f.warn("StorageMap: Failed to clear data from sessionStorage");
    }
  }
}
function V(s) {
  if (!s)
    return s;
  try {
    const e = new URL(s, "https://images.ctfassets.net");
    return e.protocol = "https:", e.href;
  } catch (e) {
    return f.error(`Recevied invalid asset url "${s}"`, e), s;
  }
}
function U(s) {
  if (typeof structuredClone == "function")
    return structuredClone(s);
  try {
    return JSON.parse(JSON.stringify(s));
  } catch (e) {
    return f.warn("Failed to clone data, updates are done on the original one", s, e), s;
  }
}
function W() {
  var s;
  try {
    return ((s = window.top) == null ? void 0 : s.location.href) !== window.location.href;
  } catch {
    return !0;
  }
}
function Z() {
  return `${performance.now()}-${Math.random().toString(36).slice(2)}`;
}
function X(s, e = 500) {
  let t = window.location.href;
  const n = setInterval(() => {
    const o = window.location.href;
    o !== t && (t = o, s(o));
  }, e);
  return () => clearInterval(n);
}
const b = "Asset";
var d = /* @__PURE__ */ ((s) => (s.FIELD_ID = "data-contentful-field-id", s.ENTRY_ID = "data-contentful-entry-id", s.LOCALE = "data-contentful-locale", s))(d || {});
function T(s) {
  return !!(s && typeof s == "object" && "sys" in s && s.sys.id);
}
function M(s) {
  return "linkType" in s.sys && s.sys.linkType === b;
}
const L = /* @__PURE__ */ new Map();
function R(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
function F(s) {
  setTimeout(() => {
    L.delete(s);
  }, 300);
}
function ee(s, e) {
  const t = L.get(s);
  if (t)
    return t;
  const i = new Promise((n) => {
    const o = (r) => {
      typeof r.data != "object" || !r.data || r.data.from === "live-preview" && r.data.action === "UNKNOWN_REFERENCE_LOADED" && r.data.reference.sys.id === s && (n({
        reference: r.data.reference,
        typeName: r.data.contentType ? R(r.data.contentType.sys.id) : b
      }), F(s), window.removeEventListener("message", o));
    };
    window.addEventListener("message", o), g({
      action: "ENTITY_NOT_KNOWN",
      referenceEntityId: s,
      referenceContentType: e ? b : void 0
    });
  });
  return L.set(s, i), i;
}
async function I({
  entityReferenceMap: s,
  referenceId: e,
  isAsset: t
}) {
  var n, o;
  const i = s.get(e);
  if (!i) {
    const r = await ee(e, t);
    return {
      reference: r.reference,
      typeName: r.typeName
    };
  }
  return {
    reference: i,
    typeName: (o = (n = i.sys.contentType) == null ? void 0 : n.sys) != null && o.id ? R(i.sys.contentType.sys.id) : b
  };
}
const m = `current-${d.FIELD_ID}`, _ = `current-${d.ENTRY_ID}`, D = `current-${d.LOCALE}`, N = "contentful-tooltip", te = 32, se = 5;
class ie {
  constructor({ locale: e }) {
    u(this, "tooltip", null);
    // this tooltip scrolls to the correct field in the entry editor
    u(this, "currentElementBesideTooltip", null);
    // this element helps to position the tooltip
    u(this, "defaultLocale");
    this.tooltip = null, this.currentElementBesideTooltip = null, this.defaultLocale = e, this.updateTooltipPosition = this.updateTooltipPosition.bind(this), this.addTooltipOnHover = this.addTooltipOnHover.bind(this), this.createTooltip = this.createTooltip.bind(this), this.clickHandler = this.clickHandler.bind(this), this.createTooltip(), window.addEventListener("scroll", this.updateTooltipPosition), window.addEventListener("mouseover", this.addTooltipOnHover);
  }
  // Handles incoming messages from Contentful
  receiveMessage(e) {
    e.action === "INSPECTOR_MODE_CHANGED" && document.body.classList.toggle("contentful-inspector--active", e.isInspectorActive);
  }
  // Updates the position of the tooltip
  updateTooltipPosition() {
    var i;
    if (!this.currentElementBesideTooltip || !this.tooltip)
      return !1;
    const e = this.currentElementBesideTooltip.getBoundingClientRect(), t = (i = this.tooltip.parentElement) == null ? void 0 : i.getBoundingClientRect();
    if (e && t) {
      let n = e.top - te;
      const o = e.left - se;
      return n < 0 && (e.top < 0 ? n = e.top : n = 0), this.tooltip.style.top = n + "px", this.tooltip.style.left = o + "px", !0;
    }
    return !1;
  }
  addTooltipOnHover(e) {
    var i, n, o;
    const t = e.composedPath();
    for (const r of t) {
      const a = r;
      if (a.nodeName === "BODY")
        break;
      if (typeof (a == null ? void 0 : a.getAttribute) != "function")
        continue;
      const l = a.getAttribute(d.FIELD_ID), c = a.getAttribute(d.ENTRY_ID), y = a.getAttribute(d.LOCALE) ?? this.defaultLocale;
      if (l && c && y) {
        this.currentElementBesideTooltip = a, this.updateTooltipPosition() && ((i = this.tooltip) == null || i.setAttribute(m, l), (n = this.tooltip) == null || n.setAttribute(_, c), (o = this.tooltip) == null || o.setAttribute(D, y));
        break;
      }
    }
  }
  createTooltip() {
    if (!document.querySelector(`.${N}`)) {
      const e = document.createElement("button");
      e.classList.add(N), e.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5325 2.22242C13.825 2.51492 13.825 2.98742 13.5325 3.27992L12.16 4.65242L9.3475 1.83992L10.72 0.467422C11.0125 0.174922 11.485 0.174922 11.7775 0.467422L13.5325 2.22242ZM0.25 13.7499V10.9374L8.545 2.64243L11.3575 5.45493L3.0625 13.7499H0.25Z" fill="white"/>
      </svg>Edit`, window.document.body.insertAdjacentElement("beforeend", e), e.addEventListener("click", this.clickHandler), this.tooltip = e;
    }
    this.updateTooltipPosition();
  }
  // responsible for handling the event when the user clicks on the edit button in the tooltip
  clickHandler() {
    if (!this.tooltip)
      return;
    const e = this.tooltip.getAttribute(m), t = this.tooltip.getAttribute(_), i = this.tooltip.getAttribute(D);
    e && t && i && g({
      action: "TAGGED_FIELD_CLICKED",
      fieldId: e,
      entryId: t,
      locale: i
    });
  }
}
function A(s, e, t) {
  var i, n, o, r, a;
  try {
    const l = e.fields.file[t];
    return {
      ...s,
      // GraphQL flattens some information
      // and as the live updates are coming from the CMA, we need to transform them
      title: e.fields.title[t],
      description: (i = e.fields.description) == null ? void 0 : i[t],
      contentType: l.contentType,
      url: V(l.url),
      // Note: video has no `width` and `height`
      width: (o = (n = l.details) == null ? void 0 : n.image) == null ? void 0 : o.width,
      height: (a = (r = l.details) == null ? void 0 : r.image) == null ? void 0 : a.height
    };
  } catch (l) {
    return f.warn("Failed update asset", { dataFromPreviewApp: s, updateFromEntryEditor: e, locale: t }, l), s;
  }
}
const ne = ["sys", "__typename", "contentfulMetadata"];
function oe(s, e) {
  const t = /* @__PURE__ */ new Set([...ne, ...s]);
  for (const i of Object.keys(e))
    t.has(i) || t.has(re(i)) || f.warn(`Unrecognized field '${i}'. Note that GraphQL aliases are not supported`);
}
const C = "Collection";
function k(s) {
  return `${s}${C}`;
}
function re(s) {
  return s.replace(C, "");
}
async function ae({
  contentType: s,
  dataFromPreviewApp: e,
  updateFromEntryEditor: t,
  locale: i,
  entityReferenceMap: n
}) {
  var a;
  if (e.sys.id !== t.sys.id)
    return e;
  const o = { ...e }, { fields: r } = s;
  oe(
    r.map((l) => l.apiName ?? l.name),
    e
  );
  for (const l of r) {
    const c = l.apiName ?? l.name;
    O(l) ? E(o, t, c, i) : l.type === "RichText" ? le({
      dataFromPreviewApp: o,
      updateFromEntryEditor: t,
      name: c,
      locale: i
    }) : l.type === "Link" ? await B({
      dataFromPreviewApp: o,
      updateFromEntryEditor: t,
      name: c,
      locale: i,
      entityReferenceMap: n
    }) : l.type === "Array" && ((a = l.items) == null ? void 0 : a.type) === "Link" && await H({
      dataFromPreviewApp: o,
      updateFromEntryEditor: t,
      name: c,
      locale: i,
      entityReferenceMap: n
    });
  }
  return o;
}
function le({
  dataFromPreviewApp: s,
  updateFromEntryEditor: e,
  name: t,
  locale: i
}) {
  var n, o;
  t in s && (s[t] || (s[t] = {}), s[t].json = ((o = (n = e == null ? void 0 : e.fields) == null ? void 0 : n[t]) == null ? void 0 : o[i]) ?? null);
}
async function ce({
  referenceFromPreviewApp: s,
  updatedReference: e,
  entityReferenceMap: t,
  locale: i
}) {
  const { reference: n } = await I({
    entityReferenceMap: t,
    referenceId: e.sys.id,
    isAsset: !0
  });
  return A(
    { ...s, ...e, __typename: b },
    n,
    i
  );
}
async function ue(s, e, t, i) {
  var a;
  const { reference: n, typeName: o } = await I({
    entityReferenceMap: t,
    referenceId: e.sys.id
  }), r = {
    ...s,
    ...e,
    __typename: o
  };
  for (const l in n.fields) {
    const c = n.fields[l][i];
    if (typeof c == "object")
      c.nodeType === "document" && (r[l] = { json: c }), c.sys && (r[l] = c, await B({
        dataFromPreviewApp: r,
        updateFromEntryEditor: n,
        locale: i,
        entityReferenceMap: t,
        name: l
      }));
    else if (Array.isArray(c) && ((a = c[0]) != null && a.sys)) {
      const y = k(l);
      r[y] = { items: c }, await H({
        dataFromPreviewApp: r,
        updateFromEntryEditor: n,
        locale: i,
        entityReferenceMap: t,
        name: l
      });
    } else
      r[l] = c;
  }
  return r;
}
async function j({
  referenceFromPreviewApp: s,
  updatedReference: e,
  entityReferenceMap: t,
  locale: i
}) {
  return e ? s && s.__typename ? s : e.__typename ? e : M(e) ? ce({
    referenceFromPreviewApp: s,
    updatedReference: e,
    entityReferenceMap: t,
    locale: i
  }) : ue(
    s,
    e,
    t,
    i
  ) : null;
}
async function B({
  dataFromPreviewApp: s,
  updateFromEntryEditor: e,
  name: t,
  locale: i,
  entityReferenceMap: n
}) {
  var o, r;
  t in s && (s[t] = await j({
    referenceFromPreviewApp: s[t],
    updatedReference: (r = (o = e == null ? void 0 : e.fields) == null ? void 0 : o[t]) == null ? void 0 : r[i],
    entityReferenceMap: n,
    locale: i
  }));
}
async function H({
  dataFromPreviewApp: s,
  updateFromEntryEditor: e,
  name: t,
  locale: i,
  entityReferenceMap: n
}) {
  var r, a;
  const o = k(t);
  if (o in s) {
    const l = ((a = (r = e == null ? void 0 : e.fields) == null ? void 0 : r[t]) == null ? void 0 : a[i]) ?? [], c = await Promise.all(
      l.map(async (y) => {
        const x = s[o].items.find((K) => K.sys.id === y.sys.id);
        return await j({
          referenceFromPreviewApp: x,
          updatedReference: y,
          entityReferenceMap: n,
          locale: i
        });
      })
    );
    s[o].items = c.filter(Boolean);
  }
}
function v(s) {
  if (Array.isArray(s)) {
    for (const e of s) {
      const t = v(e);
      if (Object.values(t).includes(!0))
        return t;
    }
    return { isGQL: !1, hasSys: !1, isREST: !1 };
  } else {
    const e = Object.hasOwn(s, "__typename"), t = Object.hasOwn(s, "sys"), i = Object.hasOwn(s, "fields");
    return e || t || i ? { isGQL: e, hasSys: t, isREST: i } : v(Object.values(s));
  }
}
function de(s) {
  let e = !0;
  const { isGQL: t, hasSys: i, isREST: n } = v(s);
  return i || (e = !1, f.error('Live Updates requires the "sys.id" to be present on the provided data', s)), !t && !n && (e = !1, f.error(
    'For live updates as a basic requirement the provided data must include the "fields" property for REST or "__typename" for Graphql, otherwise the data will be treated as invalid and live updates are not applied.',
    s
  )), {
    isGQL: t,
    isREST: n,
    hasSys: i,
    isValid: e
  };
}
function fe(s, e) {
  return s.name === "Asset" ? e.id : e.apiName || e.name;
}
async function G(s, e, t, i) {
  var r;
  const { reference: n } = await I({
    entityReferenceMap: i,
    referenceId: e.sys.id,
    ...M(e) ? { isAsset: !0 } : void 0
  });
  if (!n)
    return s;
  const o = U(n);
  for (const a in n.fields) {
    const l = n.fields[a][t];
    typeof l == "object" && l.sys ? await Y(
      o,
      n,
      t,
      a,
      i
    ) : Array.isArray(l) && ((r = l[0]) != null && r.sys) ? await $(
      o,
      n,
      t,
      a,
      i
    ) : E(o.fields, n, a, t);
  }
  return o;
}
async function $(s, e, t, i, n) {
  var o, r;
  if (!((r = (o = e.fields) == null ? void 0 : o[i]) != null && r[t])) {
    delete s.fields[i];
    return;
  }
  return s.fields[i] = await Promise.all(
    e.fields[i][t].map(
      (a, l) => {
        var c;
        return G(
          (c = s.fields[i]) == null ? void 0 : c[l],
          a,
          t,
          n
        );
      }
    )
  ).then((a) => a.filter(Boolean)), s;
}
async function Y(s, e, t, i, n) {
  var r, a;
  const o = (a = (r = e == null ? void 0 : e.fields) == null ? void 0 : r[i]) == null ? void 0 : a[t];
  if (!o) {
    delete s.fields[i];
    return;
  }
  return s.fields[i] = await G(
    s.fields[i],
    o,
    t,
    n
  ), s;
}
async function he(s, e, t, i, n) {
  var o;
  if (e.sys.id !== t.sys.id)
    return e;
  try {
    for (const r of s.fields) {
      const a = fe(s, r);
      O(r) || r.type === "RichText" || r.type === "File" ? E(e.fields, t, a, i) : r.type === "Link" ? await Y(
        e,
        t,
        i,
        a,
        n
      ) : r.type === "Array" && ((o = r.items) == null ? void 0 : o.type) === "Link" && await $(
        e,
        t,
        i,
        a,
        n
      );
    }
  } catch (r) {
    console.error(">> error", r);
  }
  return e;
}
class pe {
  constructor({ locale: e }) {
    u(this, "subscriptions", /* @__PURE__ */ new Map());
    u(this, "storage");
    u(this, "defaultLocale");
    this.defaultLocale = e, this.storage = new P("live-updates", /* @__PURE__ */ new Map()), window.addEventListener("beforeunload", () => this.clearStorage());
  }
  async mergeEntity({
    contentType: e,
    dataFromPreviewApp: t,
    entityReferenceMap: i,
    locale: n,
    updateFromEntryEditor: o
  }) {
    return "__typename" in t ? t.__typename === "Asset" ? {
      data: A(t, o, n),
      updated: !0
    } : {
      data: await ae({
        contentType: e,
        dataFromPreviewApp: t,
        updateFromEntryEditor: o,
        locale: n,
        entityReferenceMap: i
      }),
      updated: !0
    } : this.isCfEntity(t) ? {
      data: await he(
        e,
        t,
        o,
        n,
        i
      ),
      updated: !0
    } : { updated: !1, data: t };
  }
  /**
   * Merges the `dataFromPreviewApp` together with the `updateFromEntryEditor`
   * If there is not direct match, it will try to merge things together recursively
   * caches the result if cache is enabled and the entity has a `sys.id`.
   * Caching should not be enabled for every entry,
   * because nested references could be merged differently together and this could solve to data loss.
   */
  async mergeNestedReference({ dataFromPreviewApp: e, ...t }, i) {
    const n = T(e) && e.sys.id, o = i && n;
    let r = !1, a = (o ? this.storage.get(n) : void 0) || e;
    if (T(a) && n === t.updateFromEntryEditor.sys.id) {
      const l = await this.mergeEntity({ ...t, dataFromPreviewApp: a });
      a = l.data, r = l.updated;
    } else
      for (const l in a)
        if (a[l] && typeof a[l] == "object") {
          const c = await this.merge(
            { ...t, dataFromPreviewApp: a[l] },
            !1
          );
          a[l] = c.data, r = r || c.updated;
        }
    return o && this.storage.set(n, a), { data: a, updated: r };
  }
  async merge({ dataFromPreviewApp: e, ...t }, i = !0) {
    if (Array.isArray(e)) {
      const n = [];
      let o = !1;
      for (const r of e) {
        const a = await this.mergeNestedReference(
          { ...t, dataFromPreviewApp: r },
          i
        );
        n.push(a.data), o = o || a.updated;
      }
      return { data: n, updated: o };
    }
    return this.mergeNestedReference({ ...t, dataFromPreviewApp: e }, i);
  }
  isCfEntity(e) {
    return T(e) && "fields" in e;
  }
  /** Receives the data from the message event handler and calls the subscriptions */
  async receiveMessage(e) {
    if (e.action === "ENTRY_UPDATED") {
      const { entity: t, contentType: i, entityReferenceMap: n } = e;
      await Promise.all(
        [...this.subscriptions].map(async ([, o]) => {
          try {
            const { updated: r, data: a } = await this.merge({
              // Clone the original data on the top level,
              // to prevent cloning multiple times (time)
              // or modifying the original data (failure potential)
              dataFromPreviewApp: U(o.data),
              locale: o.locale || this.defaultLocale,
              updateFromEntryEditor: t,
              contentType: i,
              entityReferenceMap: n
            });
            r && o.callback(a);
          } catch (r) {
            f.error("Failed to apply live update", {
              error: r,
              subscribedData: o.data,
              updateFromEditor: t
            });
          }
        })
      );
    }
  }
  restore(e, t) {
    if (!e)
      return;
    const i = (n) => {
      if (T(n)) {
        const o = this.storage.get(n.sys.id);
        if (o)
          return o;
      }
      return n;
    };
    if (Array.isArray(e)) {
      const n = e.map(i), o = this.subscriptions.get(t);
      o && o.callback(n);
    } else {
      const n = i(e);
      if (n !== e) {
        const o = this.subscriptions.get(t);
        o && o.callback(n);
      }
    }
  }
  clearStorage() {
    this.storage.clear();
  }
  /**
   * Subscribe to data changes from the Editor, returns a function to unsubscribe
   * Will be called once initially for the restored data
   */
  subscribe({ data: e, locale: t, callback: i }) {
    const { isGQL: n, isValid: o } = de(e);
    if (!o)
      return () => {
      };
    const r = Z();
    return this.subscriptions.set(r, { data: e, locale: t, callback: i }), setTimeout(() => {
      this.restore(e, r);
    }, 0), g({
      action: "SUBSCRIBED",
      type: n ? "GQL" : "REST"
    }), () => {
      this.subscriptions.delete(r);
    };
  }
}
const h = class {
  // Static method to initialize the LivePreview SDK
  static init(e) {
    if (typeof e != "object" || !(e != null && e.locale))
      throw new Error(
        "Init function have to be called with a locale configuration (for example: `ContentfulLivePreview.init({ locale: 'en-US'})`)"
      );
    const { debugMode: t, enableInspectorMode: i, enableLiveUpdates: n, locale: o } = e;
    if (typeof window < "u")
      return W() ? (t && q(t), typeof i == "boolean" && (this.inspectorModeEnabled = i), typeof n == "boolean" && (this.liveUpdatesEnabled = n), this.locale = o, h.initialized ? (f.log("You have already initialized the Live Preview SDK."), Promise.resolve(h.inspectorMode)) : (this.inspectorModeEnabled && (h.inspectorMode = new ie({ locale: o })), this.liveUpdatesEnabled && (h.liveUpdates = new pe({ locale: o })), window.addEventListener("message", (r) => {
        var a, l;
        typeof r.data != "object" || !r.data || r.data.from === "live-preview" && (this.inspectorModeEnabled && ((a = h.inspectorMode) == null || a.receiveMessage(r.data)), this.liveUpdatesEnabled && ((l = h.liveUpdates) == null || l.receiveMessage(r.data)));
      }), X(() => {
        g({ action: "URL_CHANGED" });
      }), g({
        action: "IFRAME_CONNECTED",
        connected: !0,
        tags: document.querySelectorAll(`[${d.ENTRY_ID}]`).length
      }), this.initialized = !0, Promise.resolve(h.inspectorMode))) : (this.liveUpdatesEnabled = !1, Promise.resolve(null));
  }
  static subscribe(e) {
    if (!this.liveUpdatesEnabled)
      return () => {
      };
    if (!this.liveUpdates)
      throw new Error(
        "Live Updates are not initialized, please call `ContentfulLivePreview.init()` first."
      );
    return e.locale ? this.liveUpdates.subscribe(e) : this.liveUpdates.subscribe({ ...e, locale: this.locale });
  }
  // Static method to render live preview data-attributes to HTML element output
  static getProps({ fieldId: e, entryId: t, locale: i }) {
    return this.inspectorModeEnabled ? !e || !t ? (f.warn("Missing property for inspector mode", { fieldId: e, entryId: t }), null) : {
      [d.FIELD_ID]: e,
      [d.ENTRY_ID]: t,
      [d.LOCALE]: i
    } : null;
  }
  static toggleInspectorMode() {
    return this.inspectorModeEnabled = !this.inspectorModeEnabled, this.inspectorModeEnabled;
  }
  static toggleLiveUpdatesMode() {
    return this.liveUpdatesEnabled = !this.liveUpdatesEnabled, this.liveUpdatesEnabled;
  }
};
let p = h;
u(p, "initialized", !1), u(p, "inspectorMode", null), u(p, "liveUpdates", null), u(p, "inspectorModeEnabled", !0), u(p, "liveUpdatesEnabled", !0), u(p, "locale");
export {
  p as C,
  be as d
};
//# sourceMappingURL=index-b017ab55.js.map
